import { IMyWindow } from '@aca-new/app/shared/interfaces/my-window.interface';
import { InjectionToken } from '@angular/core';

export const WINDOW = new InjectionToken<IMyWindow>('Universal Window object to use instead of accessing directly the window (Angular way)');
